import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    "id": undefined, // optional Mã tự sinh
    "duyet": // optional Thông tin duyệt
    {
        "duoc_duyet": undefined, // required Cho biết điểm đến đã được duyệt hay chưa
        "thoi_diem_duoc_duyet": undefined, // optional Cho biết thời điểm điểm đến đã được duyệt
        "nguoi_duyet_id": undefined, // optional Mã người duyệt
    },
    "hoat_dong": // optional Thông tin hoạt động
    {
        "ngung_hoat_dong": null, // optional Cho biết đơn vị có đang ngừng hoạt động hay không. Mặc định là đang hoạt động
        "thoi_diem_thay_doi_cuoi": null, // optional Thời điểm ngừng hoạt động/hoạt động trở lại (gần nhất) - Do người dùng SafePlace đổi
        "lich_su_thay_doi": [ // optional Lịch sử các lần thay đổi trạng thái hoạt động
        {
            "ngung_hoat_dong": null, // required Cho biết có phải trạng thái thay đổi về ngừng hoạt động hay không
            "thoi_diem": null, // required Thời điểm thay đổi
            "nguoi_thay_doi_id": null, // required Mã người thay đổi
        }],
    },
    "loai_diem_den": undefined, // required, enum(international_travel, domestic_travel, hotel, tourist_villa, tourist_apartment, tourist_cruise, camping, motel, homestay, tourist_carriers, shopping, restaurant, tourist_area, tourist_attraction, entertainment) Loại điểm đến
    "thong_tin_chung": // optional Thông tin chung
    {
        "ten": undefined, // required Tên điểm đến
        "anh": undefined, // optional Mã ảnh đại diện trên hệ thống survey
        "giay_to": // optional Thông tin giấy tờ định danh điểm đến
        {
            "so_giay_to": undefined, // optional Mã số thuế/Mã số doanh nghiệp
            "noi_cap": undefined, // optional Nơi cấp
            "ngay_cap": undefined, // optional Ngày cấp
            "scan": [], // optional Danh sách mã ảnh scan
            "dia_chi": undefined, // optional Địa chỉ trên đăng ký kinh doanh
        },
        "dia_chi": // optional Thông tin địa chỉ
        {
            "quoc_gia": undefined, // optional Quốc gia
            "quoc_tich_id": undefined, // optional Mã quốc tịch
            "tinh": undefined, // optional Tên tỉnh
            "tinh_id": undefined, // optional Mã tỉnh
            "xa": undefined, // optional Tên xa
            "xa_id": undefined, // optional Mã xã
            "dia_chi": undefined, // optional Địa chỉ giao dịch
            "kinh_do": undefined, // optional Kinh độ
            "vi_do": undefined, // optional Vĩ độ
        },
        "nguoi_dai_dien": // optional Thông tin người đại diện
        {
            "ho_ten": undefined, // optional Họ và tên
            "chuc_vu": undefined, // optional Chức vụ
            "ngay_sinh": undefined, // optional Ngày sinh
            "so_giay_to": undefined, // optional Số CMT/ Căn cước/ Hộ chiếu
            "gioi_tinh": undefined, // optional Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
            "dia_chi": undefined, // optional Địa chỉ
            "dien_thoai": undefined, // optional Điện thoại
            "email": undefined, // optional Email
        },
        "trang_vang": undefined, // optional Cho biết điểm đến này có được duyệt trên trang vàng hay không
        "loai_hinh_uu_dai": undefined, // optional, enum(giam_gia_tien, giam_gia_phan_tram) - Loại hình ưu đãi
        "gia_tri_uu_dai": undefined, // optional, min: 0 - Giá trị ưu đãi
        "huong_dan_vien": // optional - Các thông tin cho hướng dẫn viên
        {
            "uu_dai": // optional - Thông tin ưu đãi
            {
                "loai_hinh_uu_dai": undefined, // optional, enum(giam_gia_tien, giam_gia_phan_tram) - Loại hình ưu đãi
                "gia_tri_uu_dai": undefined, // optional, min: 0 - Giá trị ưu đãi
            }
        }
    },
    "du_lieu_khai_bao": // optional Dữ liệu khai báo khi đăng ký điểm đến
    {
        "user_account": undefined, // optional account của điểm đến
    },
    "nguoi_tao_id": undefined, // required Mã người tạo
    "thoi_diem_tao": undefined, // required Thời điểm tạo
    "noi_dung_hien_thi":[  // optional Nội dung hiển thị
        {
            "ngon_ngu": undefined, // required Ngôn ngữ hiển thị
            "gioi_thieu": undefined, // required Giới thiệu thông tin
            "anh_id": undefined, // optional Id của ảnh hiển thị
            "noi_dung": undefined, // required Nội dung hiển thị
        }
    ],
    "ngon_ngu": "vi",
    "noiDungHienThiFilter": {
        // "gioi_thieu": undefined,
        // "anh_id": undefined,
        "noi_dung": undefined,
    },
    "listImageUrl": {
        'anh_id': undefined,
        "tieu_de": undefined,
        "ngon_ngu": undefined,
        'type': undefined
    },
    'albumAnhFilter': {
        'anh_id':undefined
    }
};

export default model;
